import CookieStorage from './CookieStorage';
import cookie from 'cookie';
import Gateway from '../Gateway';

export default class SearchQuery extends CookieStorage {
  constructor() {
    super();
    const valueFromCookie = cookie.parse(Gateway.window.document.cookie)[this.key];
    this.data = valueFromCookie ? valueFromCookie : this._defaultValue;
  }

  get key() {
    return 'sa_search_query'
  }

  get _defaultValue() {
    return false;
  }

  set value(value) {
    this.data = !!value;
    this._save();
  }
}
